// extracted by mini-css-extract-plugin
export var icon = "Icon-module--icon--3h62H";